import React from 'react';
import { Link } from 'react-router';
import { get } from 'lodash';

class RowItemDanhSachThemMoiThanhTra extends React.Component {

  render() {
    const { nhomDoiTuongThanhTraInfo, ma, quanHuyenInfo, phuongXaInfo, diaChi } = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten}</td>
        <td>{get(nhomDoiTuongThanhTraInfo, 'ten')}</td>
        <td>{ma}</td>
        <td>{get(quanHuyenInfo, 'name')}</td>
        <td>{get(phuongXaInfo, 'name')}</td>
        <td>{diaChi}</td>
        <td>
          <div className="todo-wrap txt-center">
            <div className="wrap-link-todo">
              <Link className="itt-remove" onClick={this.props.parent.hanldeRemove.bind(this.props.parent, this.props.count - 1)}>Loại</Link>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}


export default RowItemDanhSachThemMoiThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachThemMoiThanhTra.jsx